import React, { useEffect, useRef, useState } from 'react';
import tapIcon from '../../services/TapIcon';
import { useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import { Helmet } from 'react-helmet';
import HttpAPICall from "../../services/HttpAPICall";
import DatePicker from "react-datepicker";
import { toast } from 'react-toastify';
import moment from 'moment';
import FuelVolumeGraph from './DeviceGraph';


const VoltageGraph = (props) => {
    const firstLoad = useRef(false);
    const [imei, setImei] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [deviceData, setDeviceData] = useState(null);

    const access_token = useSelector(state => state.auth.access_token);

    useEffect(() => {
        const now = new Date();
        const twelveHoursAgo = new Date(now.getTime() - 12 * 60 * 60 * 1000);

        setStartDate(twelveHoursAgo);
        setEndDate(now);
    }, []);
    useEffect(() => {
        if (props.deviceData?.imei_no) {
            setImei(props.deviceData.imei_no);
        }
    }, [props.deviceData?.imei_no]);

    useEffect(() => {
        if (
            !firstLoad.current &&
            imei &&
            startDate &&
            endDate
        ) {
            firstLoad.current = true;
            fetchDeviceData(imei, startDate, endDate);
        }
    }, [imei, startDate, endDate]);

    const fetchDeviceData = (imei, startDate, endDate) => {
        setLoading(true);
        setDeviceData(null);

        const requestBody = {
            imeIs: [imei.trim()],
            startDate: new Date(startDate).toISOString(),
            endDate: new Date(endDate).toISOString()
        };

        HttpAPICall.withAthorization('POST', `https://api6.tappetbox.in/api/DeviceData/get-historical`, access_token, {}, requestBody, (resp) => {
            setDeviceData(resp.data);
            toast.success('Device data fetched successfully', { position: toast.POSITION.TOP_RIGHT });
        }, (error) => {
            toast.error('Failed to fetch device data', { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleDateTimeChange = (field, value) => {
        if (field === 'startDate') {
            setStartDate(value);
        } else if (field === 'endDate') {
            setEndDate(value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!imei) {
            toast.error('Please select an IMEI number', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        if (!startDate || !endDate) {
            toast.error('Please select both start and end dates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        fetchDeviceData(imei, startDate, endDate);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    const handleLocationClick = (latitude, longitude) => {
        if (!latitude || !longitude || isNaN(parseFloat(latitude)) || isNaN(parseFloat(longitude))) {
            toast.error('Invalid location coordinates', { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    };

    const formatValue = (key, value, record = null) => {
        if (value === null || value === undefined) return 'N/A';

        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }

        if (typeof value === 'number') {
            switch (key) {
                case 'speed':
                    return `${value} km/h`;
                case 'direction':
                    return `${value}°`;
                case 'altitude':
                    return `${value} m`;
                case 'externalVoltage':
                case 'batteryVoltage':
                    return `${value} V`;
                default:
                    return value.toString();
            }
        }


        if ((key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) && !isNaN(Date.parse(value))) {
            return moment(value).format('DD-MMM-YYYY HH:mm:ss');
        }

        if (key.toLowerCase().includes('imei') && record) {
            const hasValidLocation = record.latitude && record.longitude &&
                !isNaN(parseFloat(record.latitude)) && !isNaN(parseFloat(record.longitude));

            if (hasValidLocation) {
                return (
                    <button
                        className="btn btn-link p-0 text-primary text-decoration-none"
                        onClick={() => handleLocationClick(
                            record.latitude,
                            record.longitude,
                        )}
                    >
                        {value}
                    </button>
                );
            }
        }

        return value.toString();
    };

    return (
        <>
            <Helmet><title>Device History</title></Helmet>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white p-3">
                            {props?.deviceData?.asset &&
                                <table className="table table-hover table-borderless mt-2">
                                    <tbody>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}>Asset </td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.asset?.asset_name || "-"}({props?.deviceData?.asset?.asset_nickname || "-"})</td>
                                        </tr>
                                        <tr>
                                            <td className="details-label" style={{ "width": "34%" }}> Group</td>
                                            <td className="details-name" style={{ "width": "66%" }}>{props?.deviceData?.group?.group_name || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                            <form onSubmit={handleSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="imei" className="form-label require">IMEI</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={imei || ''}
                                            readOnly
                                            disabled
                                            placeholder="IMEI Number"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="startDate" className="form-label require">Start Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(value) => handleDateTimeChange('startDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter Start Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-4">
                                        <label htmlFor="endDate" className="form-label require">End Date</label>
                                    </div>
                                    <div className="col-sm-4">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(value) => handleDateTimeChange('endDate', value)}
                                            dateFormat="dd-MMM-yyyy HH:mm"
                                            className="form-control"
                                            showMonthDropdown
                                            showYearDropdown
                                            showTimeSelect
                                            timeFormat="HH:mm"
                                            timeIntervals={15}
                                            timeCaption="Time"
                                            autoComplete="off"
                                            scrollMonthYearDropdown
                                            required={true}
                                            placeholderText="Please Enter End Date & Time"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-7"></div>
                                    <div className="col-sm-2">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary "
                                        >
                                            GO
                                            {loading && (
                                                <>
                                                    <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin ms-2" />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            {!loading && deviceData && (
                                <FuelVolumeGraph
                                    deviceData={deviceData}
                                    loading={loading}
                                />
                            )}
                            {loading && <Loader />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VoltageGraph;